// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2679":"016506dc","6183":"016506dc"}[chunkId] + ".chunk.css";
};